import EditBucketModal from './EditBucketModal'

export default EditBucketModal
